module.exports = __webpack_public_path__ + "img/Flag_of_Eritrea.8ef90a1d.svg";